import React from "react";
import ConfirmModal from "./ConfirmModal";

class ViewFamily extends React.Component {
  state = {};

  partHelper = (member, part) => {
    return (
      <div className="part">
        <img src={`images/parts/${member[part].file}`} alt="" />
      </div>
    );
  };
  deleteButtonHelper = (id) => {
    if (this.props.globalState.family.length > 1) {
      return (
        <ConfirmModal
          modalId="delmodal"
          label="Delete"
          buttonClass="inline-link"
          iconClass="far fa-times"
          question="Are you sure you want to delete this AVATAR?"
          title="Delete AVATAR?"
          action={() => this.props.removeRecord(id)}
        />
      );
    }
    return null;
  };
  memberHelper = () => {
    let membersHTML = this.props.globalState.family.map((member) => {
      return (
        <div className={`member col-8 col-sm-6 col-md-4 pb-3 size-${member.size}`} key={member.id}>
          <div className="name">
            <h3>{member.name}</h3>
          </div>
          <div className="avatar">
            {this.partHelper(member, "outfit")}
            {this.partHelper(member, "gear")}
            {this.partHelper(member, "accessories")}
          </div>
          <div className="text-right py-1">
            <button type="button" className="inline-link" onClick={() => this.props.goTo("BuildAvatar", member.id)}>
              Edit<i className="fas fa-pencil" aria-hidden="true"></i>
            </button>
            {this.deleteButtonHelper(member.id)}
          </div>
        </div>
      );
    });
    return <div className="members row justify-content-center">{membersHTML}</div>;
  };
  render() {
    return (
      <div className="view-family">
        <section>
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h2>Your Family</h2>
              </div>
            </div>
            {this.memberHelper()}
            <div className="row">
              <div className="col text-center actions">
                <button className="btn btn-primary" type="button" onClick={() => this.props.goTo("BuildAvatar")}>
                  Add new family member
                </button>
                <button className="btn btn-line" type="button" onClick={() => this.props.goTo("Results")}>
                  Back to results
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default ViewFamily;
